import { createUseStyles } from 'react-jss';
import color from 'color';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    expanded: {},
    notActive: {},
    mainWrapper:{
        height: '100%',
    },

    graphContainer: {
        minHeight: 0,
        width: '100%',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.colors.grey_darker,
        backgroundColor: theme.colors.white,
        display: 'flex',
        flex: '1 1 0',
        flexDirection: 'column',
        overflow: 'hidden',
        // maxHeight: 'calc(100vh - 230px)',
    },

    chartViewport: {
        flex: 1,
        minHeight: 0,
        overflow: 'auto',
        position: 'relative',
    },

    chartWrapper:{
        borderTopWidth: '1px',
        borderStyle: 'solid',
        borderColor: theme.colors.grey_darker,
        minHeight: 0,
        width: '100%',
        // overflow: 'auto',
    },

    chartContainer: {
        display: "grid",
        width: "100%",
        height: "100%",
        minHeight: 0,
    },

    chartArea: {
        minWidth: 0,
        minHeight: 0,
        position: 'relative',
    },

    chartAreaBody: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        position: 'relative',
    },

    chartCanvas: {
        position: 'relative',
        minHeight: 0,
        flex: '1 1 auto',
    },

    interactiveChartArea: {
        position: 'relative',
        height: '100%',
        paddingTop: 0,
    },

    stickyTimeHeader: {
        position: 'sticky',
        top: 0,
        flex: '0 0 62px',
        zIndex: 4,
        height: 62,
        overflow: 'hidden',
        background: `linear-gradient(180deg, ${theme.colors.white} 0%, ${theme.colors.white} 100%)`,
        borderBottom: `1px solid ${theme.colors.grey_darker}`,
        pointerEvents: 'none',
        backdropFilter: 'blur(4px)',
    },

    stickyTimeHeaderContent: {
        position: 'relative',
        height: '100%',
        minWidth: '100%',
    },

    stickyStepHeader: {
        position: 'sticky',
        top: 0,
        zIndex: 4,
        height: 62,
        display: 'flex',
        alignItems: 'center',
        padding: `0 ${theme.spacing(3)}`,
        gap: 14,
        borderBottom: `1px solid ${theme.colors.grey_darker}`,
        background: `linear-gradient(180deg, ${theme.colors.white} 0%, ${theme.colors.white} 100%)`,
        fontFamily: theme.font.primary,
        fontSize: 16,
        fontWeight: 700,
        color: theme.colors.text_heading,
        backdropFilter: 'blur(4px)',
    },

    stickyStepHeaderIndex: {
        width: 56,
        flex: '0 0 56px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        color: theme.colors.grey_text,
    },

    stickyStepHeaderIndexLabel: {
        lineHeight: 1,
    },

    stepNumberToggle: {
        minWidth: 38,
        height: 18,
        padding: '0 6px',
        border: `1px solid ${theme.colors.grey_darker}`,
        borderRadius: 999,
        background: theme.colors.white,
        color: theme.colors.violet_primary,
        fontFamily: theme.font.secondary,
        fontSize: 10,
        fontWeight: 700,
        lineHeight: 1,
        cursor: 'pointer',
    },

    stickyStepHeaderLabel: {
        flex: 1,
        minWidth: 0,
    },

    duplicateToggle: {
        height: 28,
        padding: '0 10px',
        border: `1px solid ${color(theme.colors.grey_darker).alpha(0.8).toString()}`,
        borderRadius: 999,
        background: color(theme.colors.white).alpha(0.92).toString(),
        color: theme.colors.grey_text,
        fontFamily: theme.font.secondary,
        fontSize: 11,
        fontWeight: 700,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        cursor: 'pointer',
        transition: 'background-color 120ms ease, border-color 120ms ease, color 120ms ease',
        '&:hover': {
            borderColor: color(theme.colors.violet_primary).alpha(0.24).toString(),
            color: theme.colors.violet_primary,
        },
    },

    duplicateToggleActive: {
        borderColor: color(theme.colors.violet_primary).alpha(0.18).toString(),
        background: 'rgba(95, 75, 139, 0.06)',
        color: theme.colors.violet_primary,
    },

    duplicateToggleTrack: {
        width: 24,
        height: 14,
        padding: 2,
        borderRadius: 999,
        background: color(theme.colors.grey_darker).alpha(0.5).toString(),
        display: 'inline-flex',
        alignItems: 'center',
        transition: 'background-color 120ms ease',
        '$duplicateToggleActive &': {
            background: color(theme.colors.violet_primary).alpha(0.35).toString(),
            justifyContent: 'flex-end',
        },
    },

    duplicateToggleThumb: {
        width: 10,
        height: 10,
        borderRadius: '50%',
        background: theme.colors.white,
        boxShadow: '0 1px 3px rgba(0,0,0,0.18)',
    },

    duplicateToggleLabel: {
        lineHeight: 1,
        whiteSpace: 'nowrap',
    },

    duplicateToggleCount: {
        minWidth: 16,
        height: 16,
        padding: '0 4px',
        borderRadius: 999,
        background: color(theme.colors.violet_primary).alpha(0.12).toString(),
        color: theme.colors.violet_primary,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 10,
        lineHeight: 1,
    },

    axisBody: {
        minHeight: 0,
        position: 'relative',
    },

    stickyTimeTick: {
        position: 'absolute',
        top: 10,
        transform: 'translateX(-50%)',
        fontFamily: theme.font.secondary,
        fontSize: 12,
        color: theme.colors.grey_text,
        whiteSpace: 'nowrap',
    },

    stickyTimeFlag: {
        position: 'absolute',
        top: 8,
        transform: 'translateX(-100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 4,
    },

    stickyTimeFlagMain: {
        position: 'relative',
        minWidth: 40,
        padding: '5px 12px 5px 10px',
        background: theme.colors.violet_primary,
        color: theme.colors.white,
        fontFamily: theme.font.secondary,
        fontSize: 11,
        fontWeight: 700,
        borderRadius: '6px 0 0 6px',
        '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: -10,
            width: 0,
            height: 0,
            borderTop: '13px solid transparent',
            borderBottom: '13px solid transparent',
            borderLeft: `10px solid ${theme.colors.violet_primary}`,
        },
    },

    stickyTimeFlagSub: {
        display: 'inline-flex',
        alignItems: 'center',
        minHeight: 18,
        padding: '0 8px',
        borderRadius: 999,
        background: 'rgba(95, 75, 139, 0.1)',
        color: theme.colors.violet_primary,
        fontFamily: theme.font.secondary,
        fontSize: 11,
        fontWeight: 700,
    },

    snapLine: {
        position: 'absolute',
        top: 0,
        bottom: 40,
        width: 0,
        borderLeft: `1px dashed ${theme.colors.violet_primary}`,
        pointerEvents: 'none',
        zIndex: 2,
    },

    snapPopup: {
        position: 'absolute',
        zIndex: 3,
        minWidth: 112,
        padding: '7px 9px',
        borderRadius: 8,
        background: theme.colors.white,
        border: `1px solid ${theme.colors.grey_darker}`,
        boxShadow: '0 8px 18px rgba(0,0,0,0.12)',
        pointerEvents: 'none',
    },

    snapPopupTitle: {
        fontFamily: theme.font.secondary,
        fontSize: 11,
        fontWeight: 700,
        color: theme.colors.grey_text,
        lineHeight: 1.2,
        marginBottom: 4,
    },

    snapPopupTime: {
        fontFamily: theme.font.secondary,
        fontSize: 14,
        fontWeight: 700,
        color: theme.colors.violet_primary,
        lineHeight: 1.2,
    },

    yAxisContainer:{
        height: "100%",
        overflow: "hidden",
        background: "inherit",
        minWidth: 220,
        borderRight: `1px solid ${theme.colors.grey_darker}`,
        [theme.down('tablet')]: {
            minWidth: 80,
        },
    },

    resizeHandle: {
        width: 8,
        cursor: 'col-resize',
        position: 'relative',
        background: `linear-gradient(to right, ${theme.colors.white} 0%, ${theme.colors.grey_lighter} 48%, ${theme.colors.white} 100%)`,
        borderRight: `1px solid ${theme.colors.grey_darker}`,
        '&::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 3,
            height: 36,
            borderRadius: 999,
            background: theme.colors.violet_primary,
            opacity: 0.22,
        },
    },

    scrollbarSpacer: {
        height: 40,
        width: '100%',
        borderTop: `1px solid ${theme.colors.grey_darker}`,
    },

    legendFooter: {
        flex: '0 0 auto',
        minHeight: 48,
        padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(4),
        borderTop: `1px solid ${theme.colors.grey_darker}`,
        background: theme.colors.white,
        flexWrap: 'wrap',
    },

    legendItem: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        fontFamily: theme.font.secondary,
        fontSize: 14,
        color: theme.colors.text_heading,
    },

    legendSwatch: {
        width: 20,
        height: 20,
        borderRadius: 5,
        flexShrink: 0,
        border: `1px solid ${theme.colors.grey_darker}`,
        position: 'relative',
        boxSizing: 'border-box',
    },

    legendMandatory: {
        borderWidth: 1,
        borderColor: theme.colors.border_subtle,
        borderLeft: `5px solid ${theme.colors.tree_node_bg}`,
        boxShadow: '0 0 0 1px rgba(36, 22, 74, 0.12)',
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            width: 5,
            background: theme.colors.tree_node_bg,
            borderTopLeftRadius: 5,
            borderBottomLeftRadius: 5,
        },
    },

    legendShort: {
        borderStyle: 'dashed',
        borderColor: theme.colors.tree_node_accent,
        backgroundColor: 'rgba(124, 58, 237, 0.12)',
    },

    legendStarted: {
        backgroundColor: 'rgba(91, 60, 196, 0.12)',
    },

    legendStartedArrow: {
        position: 'absolute',
        left: 4,
        right: 4,
        top: '50%',
        height: 2,
        transform: 'translateY(-50%)',
        backgroundColor: theme.colors.tree_node_bg,
        '&::after': {
            content: '""',
            position: 'absolute',
            right: -1,
            top: -4,
            width: 0,
            height: 0,
            borderTop: '5px solid transparent',
            borderBottom: '5px solid transparent',
            borderLeft: `7px solid ${theme.colors.tree_node_bg}`,
        },
    },

    legendErrorDot: {
        position: 'absolute',
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: theme.colors.red,
        right: -3,
        top: -3,
    },

    chartContentContainer:{
        height: "100%",
        overflowX: "auto",
        overflowY: "hidden",
    },

    noSteps:{
        alignContent: 'center',
        textAlign: 'center',
        minHeight: 'calc(100dvh - 260px)',
        fallbacks: { minHeight: 'calc(100vh - 260px)' },
        width: '100%',
        fontFamily: theme.font.secondary,
        fontStyle: 'italic',
        fontSize: 20,
    },
}));
